import React from "react"
import { AuthContextType } from "../../../features/auth/AuthContext"
import { fetchUserIsRunning, toggleUserIsRunning } from "../../../api/account"
import { fetchProcessReadiness } from "../../../api/account"
import CompareSiteSettings from "./CompareSiteSettings"

interface IsRunningSwitchProps {
    auth: AuthContextType,
    setErrorMessage: (arg: string) => void,
    isUserRunning: boolean,
    onIsUserRunningChange: (isRunning: boolean) => void,
    toggleLogPannel?: (arg: boolean) => void,
}

const IsRunningSwitch: React.FC<IsRunningSwitchProps> = (props) => {

    const {
        auth,
        setErrorMessage,
        isUserRunning,
        onIsUserRunningChange,
    } = props;

    // 작업실행 상태 최초 셋업
    React.useEffect(() => {
        fetchUserIsRunning({
            setResult: onIsUserRunningChange,
        });
    }, [onIsUserRunningChange])

    const handleUserIsRunning = async () => {
        // 결제 상태가 아닌 경우 실행 방지
        const isPaid = auth.subscriptionStatus?.is_valid || false;
        if (!isPaid && !isUserRunning) {
            setErrorMessage("활성화된 결제 상품이 없습니다. 결제 또는 연장 후 다시 시도해주세요.");
            return;
        }

        if (!isUserRunning) {
            const readiness = await fetchProcessReadiness();
            if (!readiness?.ready) {
                const message = readiness?.errors[0]?.message
                    || "죄송합니다. 사용자 전용 환경을 준비 중입니다. 관리자에게 문의해주세요.";
                setErrorMessage(message);
                return;
            }
        }

        toggleUserIsRunning({
            auth,
            setErrorMessage,
            setResult: (isRunning) => {
                onIsUserRunningChange(isRunning);
                if (isRunning) {
                    auth.refreshProcessReadiness();
                }
            },
        })
    }

    const isPaid = auth.subscriptionStatus?.is_valid || false;

    return <div className="d-flex align-items-center">
        <div className="form-check pt-1 me-2">
            <input
                type="radio"
                id="id_user_is_running_1"
                name="user_is_running"
                className="form-check-input"
                value="1"
                checked={isUserRunning ?? false}
                onChange={() => handleUserIsRunning()}
                disabled={!isPaid && !isUserRunning} // 결제 안된 상태에서는 실행 불가
            />
            <label htmlFor="id_user_is_running_1" className="form-check-label">실행</label>
        </div>
        <div className="form-check pt-1">
            <input
                type="radio"
                id="id_user_is_running_0"
                name="user_is_running"
                className="form-check-input"
                value="0"
                checked={!isUserRunning}
                onChange={() => handleUserIsRunning()}
            />
            <label htmlFor="id_user_is_running_0" className="form-check-label">정지</label>
        </div>
        <CompareSiteSettings auth={auth} />

    </div>
}

export default IsRunningSwitch;
